import { Controller } from "@hotwired/stimulus"

// Preserves the admin sidebar's scroll position across Turbo navigations.
// The sidebar re-renders on every visit (so badge counts + active highlight
// stay fresh); we only restore where the user had scrolled to so it doesn't
// jump back to the top on each click. Lives on the scrollable <nav> element.
const KEY = "admin-nav-scroll"

export default class extends Controller {
  connect() {
    const saved = sessionStorage.getItem(KEY)
    if (saved !== null) this.element.scrollTop = parseInt(saved, 10)

    this._ticking = false
    this._onScroll = () => {
      if (this._ticking) return
      this._ticking = true
      requestAnimationFrame(() => {
        sessionStorage.setItem(KEY, String(this.element.scrollTop))
        this._ticking = false
      })
    }
    this.element.addEventListener("scroll", this._onScroll, { passive: true })
  }

  disconnect() {
    this.element.removeEventListener("scroll", this._onScroll)
  }
}
